export default __webpack_public_path__ + "static/media/appScreenMb2.1aa1a628.png";